import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, List, ListItem, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../utils/IconHandler';

const AddCategoryModal = ({ open, onClose, onSave }) => {
  
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [subCategories, setSubCategories] = useState([]);

  // Efecto para limpiar el formulario cada vez que el modal se cierra
  useEffect(() => {
      if (!open) {
          resetForm();
      }
  }, [open]);

  const resetForm = () => {
      setName('');
      setSubCategories([]);
  };

  const handleSave = () => {
    if (subCategories.length === 0) {
      alert("Debes ingresar al menos una subcategoría");
      return;
    }
  
    onSave({
      name,
      subCategories
    });
    onClose();
  };

  const handleAddSubcategory = () => {
    const newSubcategory = { id: Date.now(), name: '' };  // Temporal ID for UI purposes
    setSubCategories([...subCategories, newSubcategory]);
  };

  const handleSubcategoryNameChange = (index, newName) => {
    const updatedSubCategories = subCategories.map((sub, idx) => {
      if (idx === index) {
        return { ...sub, name: newName };
      }
      return sub;
    });
    setSubCategories(updatedSubCategories);
  };

  const handleSubcategoryDelete = (id) => {
    setSubCategories(subCategories.filter(sub => sub.id !== id));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('add_category')}</DialogTitle>
      <DialogContent>
        <TextField
          label={t('category_name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="dense"
        />
        <List>
          {subCategories.map((sub, index) => (
            <ListItem key={sub.id}>
              <TextField
                label={t('sub_category')}
                value={sub.name}
                onChange={(e) => handleSubcategoryNameChange(index, e.target.value)}
                fullWidth
                margin="dense"
              />
              <IconButton style={{ marginLeft: "4px" }} onClick={() => handleSubcategoryDelete(sub.id)}>
                {getIcon('close')}
              </IconButton>
            </ListItem>
          ))}
          <ListItem>
            <Button onClick={handleAddSubcategory} startIcon={getIcon('add')}>
              {t('add_sub_category')}
            </Button>
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={handleSave} color="primary" variant="contained">{t('save')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCategoryModal;
